import Vue from "vue";
// import { i18n } from './language/lang'
import("./../assets/" + process.env.VUE_APP_CLIENTCODE  + "/scss/style.scss");
import VueRouter from "vue-router";
import { i18n } from "../plugins/i18n.js";
import store from "../store";
import { UI_CONTROL } from "../util/uiControl.js";
import {
    PATHNAME,
    COMPONENT_NAME,
  
} from "../util/constants";
import apiRenewJWT from "./../services/apiRenewJWT";
import { handleJWT, getAdminSignInResponse, getAgentSignInResponse, assigni18nLocale, isHmsFlow} from "./../util/util";
import { getAgtLoginResFromLocal, removeB2BMFfromSession, getSysLoginResFromLocal, clearLogCountFromLocal, clearAgtLoginResFromLocal, clearSysLoginResFromLocal,clearBaseSettFromLocal } from './../applocalstorage/localStorage'
import Logger from "./../services/logger";
import { FILE_NAME, LOG_TYPE } from "./../config/API_DATA";

import { VALIDATE_SUCCESS_RES, getErrorMessage } from "./../util/apiValidate";
import { clearStore } from './../store/clearStore'

import BaseConfiguration from "../config/base";
import { Event } from "./../main.js";

export const EventBus = new Vue();

// Containers
const TheContainer = () =>
    import("@/containers/TheContainer");



// Views - Pages
const Page404 = () =>
    import("@/pages/error/Page404");
const Page500 = () =>
    import("@/pages/error/Page500");

// Pages
//Booking - Flight
const Dashboard = () =>
    import("@/pages/dashboard/Dashboard");
const HoldPage = () =>
    import("@/pages/booking/flight/confirmation/HoldPage");
const SuccessPage = () =>
    import("@/pages/booking/flight/confirmation/SuccessPage");
const PendingPage = () =>
    import("@/pages/booking/flight/confirmation/PendingPage");
const FailedPage = () =>
    import("@/pages/booking/flight/confirmation/FailedPage");

const TicketNow = () =>
    import("@/pages/booking/flight/ticketing/TicketNow");
const PendingPay = () =>
    import("@/pages/recharge/payment/status/PendingPay");
const FailedPay = () =>
    import("@/pages/recharge/payment/status/FailedPay");
const SuccessPay = () =>
    import("@/pages/recharge/payment/status/SuccessPay");
const PaymentStatus = () =>
    import("@/pages/recharge/payment/paymentStatus");
const PaymentPage = () =>
    import("@/pages/booking/flight/payment/PaymentPage");
const FlightResults = () =>
    import("@/pages/booking/flight/result/FlightResults");
const TestFlightResults = () =>
    import("@/pages/booking/flight/result/testResults/withoutMarkup");
const MLFlightResults = () =>
    import("@/pages/booking/flight/multiCity/result/MLFlightResults");
const SearchPage = () =>
    import("@/pages/booking/flight/search/SearchPage");
const MyBookingPage = () =>
    import("@/pages/booking/flight/myBooking/MyBookingPage");
const MyBookingDetail = () =>
    import("@/pages/booking/flight/myBooking/MyBookingDetail");
const TicketingQueuePage = () =>
    import("@/pages/booking/flight/ticketing/TicketingQueuePage");
const TicketingQueueDetail = () =>
    import("@/pages/booking/flight/ticketing/TicketingQueueDetail");
const AgentRegistration = () =>
    import("@/pages/agent/AgentRegistration");
const AgentLogin = () =>
    import("@/pages/login/AgentLogin");


const BookingDetails =() => import('@/pages/booking/flight/myBooking/BookingDetails')

const ExchangeRate = () =>
    import("@/pages/ExchangeRate");
const SystemLogin = () =>
    import("@/pages/login/SystemLogin");
const ChangePassword = () =>
    import("@/pages/users/ChangePassword");
const ManageUsers = () =>
    import("@/pages/users/ManageUsers");
const RolesPermissions = () =>
    import("@/pages/users/RolesPermissions");
const AddUser = () =>
    import("@/pages/users/AddUser.vue");
const UserStatus = () =>
    import("@/pages/users/UserStatus");
const ApproveAgent = () =>
    import("@/pages/agent/ApproveAgent.vue");
const ManageAgent = () =>
    import("@/pages/agent/ManageAgent.vue");
const Manage = () =>
    import("@/pages/agent/Manage.vue");
// const Home = () =>
//     import ("@/pages/Home");
const Report = () =>
    import("@/pages/report/Report");
    const SystemReport = () =>
    import("@/pages/report/SystemReport");  
    const AgentPrepaidReport = () =>
    import("@/pages/report/AgentPrepaidReport"); 
    const AgentPrepaidSummary = () =>
    import("@/pages/report/AgentPrepaidSummary"); 
    const AgentPostpaidReport = () =>
    import("@/pages/report/AgentPostpaidReport"); 
    const AgentPostpaidSummary = () =>
    import("@/pages/report/AgentPostpaidSummary"); 
    const BookingReport = () =>
    import("@/pages/report/BookingReport"); 
    const TopupForecastReport = () =>
    import("@/pages/report/TopupForecastReport"); 
    const DailyOrPeriodicalSalesReport = () =>
    import("@/pages/report/DailyOrPeriodicalSalesReport"); 
    const DetailReport = () =>
    import("@/pages/report/DetailReport"); 
    const TopupProjectionReport = () =>
    import("@/pages/report/TopupProjectionReport"); 
    const CreditSalesReport = () =>
    import("@/pages/report/CreditSalesReport"); 
const PaxPage = () =>
    import("@/pages/booking/flight/pax/PaxPage");
    const Refund = () =>
    import("@/pages/booking/flight/manage/Refund");
    const Exchange = () =>
    import("@/pages/booking/flight/manage/Exchange");

const BookingStatusPage = () =>
    import("@/pages/booking/flight/confirmation/statusPage");
const TopUp = () =>
    import("@/pages/TopUp");
const SystemTopUp = () =>
    import("@/pages/SystemTopUp");
const TopupReport = () =>
    import("@/pages/topup/TopupReport");
const Route = () =>
    import("@/pages/Route");
const SetupPricing = () =>
    import("@/pages/pricing/SetupPricing");
const ManagePricing = () =>
    import("@/pages/pricing/ManagePricing");

const CreatePricing = () =>
    import("@/pages/pricing/CreatePricing");
const AssignPricing = () =>
    import("@/pages/pricing/AssignPricing");
const AddNewPricing = () =>
    import("@/pages/pricing/AddNewPricing");
const Classes = () =>
    import("@/pages/tools/Classes");
const Credit = () =>
    import("@/pages/CreditNote/Credit");
const CreditReport = () =>
    import("@/pages/CreditNote/CreditReport");
const DebitNote = () =>
    import("@/pages/Debit/DebitNote");
const DebitReport = () =>
    import("@/pages/Debit/DebitReport");

const Routes = () =>
    import('@/pages/tools/Routes');
const Currency = () =>
    import('@/pages/tools/Currency');
const StateProvince = () =>
    import('@/pages/tools/StateProvince');
const ExtensionSetUp = () =>
    import('@/pages/tools/ExtensionSetUp')
const PaymentSetup = () =>
    import('@/pages/tools/PaymentSetup')
const AddPayment = () =>
    import('@/pages/tools/AddPayment')

const PaymentFee = () =>
    import('@/pages/tools/PaymentFee.vue')

const Deposit = () =>
    import('@/pages/postpaid/Deposit.vue')
const PendingInvoices = () =>
    import('@/pages/postpaid/PendingInvoices.vue')
const ViewStatements = () =>
    import('@/pages/postpaid/ViewStatements.vue')
const ResetPassword = () =>
    import('@/pages/login/ResetPassword.vue')

const AgentDeposit = () =>
    import('@/pages/postpaid/AgentDeposit.vue')
const AgentViewStatements = () =>
    import('@/pages/postpaid/AgentViewStatements.vue')

const AgentDepositPay = () =>
    import('@/pages/postpaid/AgentDepositPay.vue')

    const ContractAll = () =>
    import("@/pages/crs/contract/all.vue");
    const ContractNew = () =>
    import("@/pages/crs/contract/new.vue");
    const FareRuleAll = () =>
    import("@/pages/crs/flight/farerule/all.vue");
    const FareRuleNew = () =>
    import("@/pages/crs/flight/farerule/new.vue");
    const ScheduleAll = () =>
    import("@/pages/crs/flight/schedule/all.vue");
    const ScheduleNew = () =>
    import("@/pages/crs/flight/schedule/new.vue");
    const FareUploadAll = () =>
    import("@/pages/crs/flight/fareupload/all.vue");
    const FareUploadNew = () =>
    import("@/pages/crs/flight/fareupload/new.vue");
    const TaxSetup = () =>
    import("@/pages/crs/tax/new.vue");
    const TaxAll = () =>
    import("@/pages/crs/tax/all.vue");
    const AllRefund = () => import('@/pages/booking/flight/manage/AllRefund.vue')
    const  RefundDet = () => import('@/pages/booking/flight/manage/RefundDet.vue')
    const AllExchange = () => import('@/pages/booking/flight/manage/AllExchange.vue')
    const  ExchangeDet = () => import('@/pages/booking/flight/manage/ExchangeDet.vue')

    const FareView = () =>
    import("@/pages/crs/flight/fareview.vue");
    const Guide = () =>
    import("@/pages/help/guide.vue");

    const AgentGroupAll = () =>
    import("@/pages/agentgroup/all.vue")
    const AgentGroupNew = () =>
    import("@/pages/agentgroup/new.vue")

    const SystemTicketNow = () =>
    import ("@/pages/booking/flight/ticketing/system/SystemTicketNow")

    const AddProfile = () => 
    import ("@/pages/offlineagent/AddProfile")
    const ProfileList = () => 
    import ("@/pages/offlineagent/ProfileList")
    const PaymentReceived = () => 
    import ("@/pages/offlineagent/PaymentReceived")
    const TourFlightResults = () => 
    import ("@/tour/pages/booking/flight/result/TourFlightResults")
    const TourMLFlightResult = () => 
    import ("@/tour/pages/booking/flight/multicity/TourMLFlightResult")
    const HotelResult = () => 
    import ("@/pages/booking/hotel/result/HotelResult")

    const NotificationSetUp = () => 
    import ("@/pages/tools/NotificationSetUp")

    const HotelInfo = () => 
    import ("@/pages/hms/manage/HotelInfo")

    const HotelRoomResult = () => 
    import ("@/pages/booking/hotel/result/HotelRoomResult")
    const GuestPage = () =>
    import("@/pages/booking/hotel/pax/GuestPage");
    const SupplierGroupAll = () => 
    import ("@/pages/hms/supplier/group/all")
    const SupplierGroupNew = () => 
    import ("@/pages/hms/supplier/group/new")
    const HotelPaymentPage = () =>
    import("@/pages/booking/hotel/payment/PaymentPage");
    const ManageAll = () => 
    import ("@/pages/hms/manage/all")
    const ManageHotelNew = () => 
    import ("@/pages/hms/manage/new")
    const TariffAll = () =>  import ("@/pages/hms/manage/hotelinfo/tariff/all")
    const CancellationAll = () =>  import ("@/pages/hms/manage/hotelinfo/cancellation/all")
    const RatePlanAll = () =>  import ("@/pages/hms/manage/hotelinfo/rateplan/all")
    const SurchargeAll = () =>  import ("@/pages/hms/manage/hotelinfo/surcharge/all")

    const TariffNew = () =>  import ("@/pages/hms/manage/hotelinfo/tariff/new")
    const CancellationNew = () =>  import ("@/pages/hms/manage/hotelinfo/cancellation/new")
    const RatePlanNew= () =>  import ("@/pages/hms/manage/hotelinfo/rateplan/new")
    const SurchargeNew = () =>  import ("@/pages/hms/manage/hotelinfo/surcharge/new")
    const HotelTaxNew= () => import('@/pages/hms/manage/hotelinfo/hoteltax/new')
    const HotelRoomSetup = () => import('@/pages/hms/manage/hotelinfo/hotelroom/new')

    const HotelUsersAll= () => import('@/pages/hms/users/all')
    const HotelUserNew= () => import('@/pages/hms/users/new')

    const MarkupAll= () => import('@/pages/hms/markup/all')
    const MarkupNew= () => import('@/pages/hms/markup/new')
    const AllHotelTaxSetup =() => import('@/pages/hms/manage/hotelinfo/hoteltax/AllHotelTaxSetup')

    const BookingManifestReport = () => import('@/pages/crs/report/BookingManifestReport.vue')
    const BookingListReport = () => import('@/pages/crs/report/BookingListReport.vue')
    const FlightLoadFactorReport = () => import('@/pages/crs/report/FlightLoadFactorReport.vue')
    const CreateSimplePricing =() => import('@/pages/pricing/simple/CreatePricing.vue')
    const ManageSimplePricing =() => import('@/pages/pricing/simple/ManagePricing') 




    // const Test= () => import('@/pages/hms/manage/hotelinfo/availability/test.vue')

      
Vue.use(VueRouter);

if(BaseConfiguration.isMobile){

            getHttpUIMbl(); 
 }
//sessionStorage.clear();

var AppPageControl;
var aProfile;
export function getHttpUIMbl() {
    try {
      if(BaseConfiguration.isDebug) console.log("getHttpUIMbl");
      AppPageControl = require('../mobile/containers/aPageControl').default;
      aProfile = require('@/mobile/pages/aProfile').default;
    } catch (err) {
            let body = Logger.buildRequest(
              FILE_NAME.HTTP_POST,
              "error in getHttpUIMbl",
              err.toString(),
              "getHttpUIMbl",
              LOG_TYPE.ERROR
            );
            Logger.getResponse(body);
          }
     
    }

const Router = new VueRouter({
    mode: "hash", // https://router.vuejs.org/api/#mode
    /*history: true,
                hashbang: false,
                saveScrollPosition: true,*/

    linkActiveClass: "active",
    scrollBehavior: () => ({ y: 0 }),
    routes: configRoutes()
});
export function updateDataEdited(isEdited) {
    Vue.prototype.$isDataEdited = isEdited;
}

export async function renewJWT() {
    let returnValue;
    if (BaseConfiguration.isDebug) console.log("renewJWT");

    try {
        let renewJWT_req = apiRenewJWT.buildRequest();
        if (renewJWT_req != null) {
            if (!(
                (store.state.sAgtLogin &&
                    store.state.sAgtLogin.signInRes &&
                    store.state.sAgtLogin.signInRes.authorization) ||
                (store.state.sSysLogin &&
                    store.state.sSysLogin.AdminSignInRes &&
                    store.state.sSysLogin.AdminSignInRes.authorization)
            )) {
                let localAgtSignInRes = getAgtLoginResFromLocal();
                let localSysSignInRes = getSysLoginResFromLocal();



                if (localAgtSignInRes) {
                    store.dispatch(
                        "sAgtLogin/SET_SIGNIN_RES",
                        JSON.parse(localAgtSignInRes)
                    );

                    store.dispatch('sDashBoard/SET_AGENT_LOGO_DET_RESPONSE', JSON.parse(localAgtSignInRes).logoDetails)

                } else if (localSysSignInRes) {
                    store.dispatch(
                        "sSysLogin/SET_ADMIN_SIGNIN_RES",
                        JSON.parse(localSysSignInRes)
                    );

                    store.dispatch('sDashBoard/SET_AGENT_LOGO_DET_RESPONSE', JSON.parse(localSysSignInRes).logoDetails)
                }
            }

            let renewJWT_res = await apiRenewJWT.getResponse(renewJWT_req);
            // console.error(renewJWT_res)

            if (VALIDATE_SUCCESS_RES(renewJWT_res)) {
                returnValue = renewJWT_res.data.data;
            } else {
                let error = getErrorMessage(renewJWT_res);

                let isJWt = handleJWT(error);
                if (!isJWt) {
                    returnValue = null;
                }
            }
        } else {
            throw "invalid request";
        }
    } catch (err) {
        if (navigator.onLine) {
            let body = Logger.buildRequest(
                FILE_NAME.ROUTER,
                "error in renewJWt",
                err.toString(),
                "renewJWt()",
                LOG_TYPE.ERROR
            );

            Logger.getResponse(body);
        }
    }
    return returnValue;
}

function configRoutes() {
    try {
        if(BaseConfiguration.isDebug) console.log("configRoutes");        
        return [{
            // path: "*",
            // redirect: PATHNAME.HOME,
            // name: "Home",
            // component: TheContainer,



            path: "*",
            redirect: PATHNAME.DASHBOARD,
            name: COMPONENT_NAME.DASHBOARD,
            component: TheContainer,

            children: [

                // {
                //     path: '/test',
                //     name:"Test",
                //     component: Test,

                //     meta: {
                //         progress: UI_CONTROL.PROGRESS
                //     }

                // },
                
                {
                    path: PATHNAME.FARE_VIEW,
                    name: COMPONENT_NAME.FARE_VIEW,
                    component: FareView,

                    meta: {
                        progress: UI_CONTROL.PROGRESS
                    }
                },
                {
                    path: PATHNAME.TAX_SETUP,
                    name: COMPONENT_NAME.TAX_SETUP,
                    component: TaxSetup,

                    meta: {
                        progress: UI_CONTROL.PROGRESS
                    }
                },
                {
                    path: PATHNAME.FARE_RULE_NEW,
                    name: COMPONENT_NAME.FARE_RULE_NEW,
                    component: FareRuleNew,

                    meta: {
                        progress: UI_CONTROL.PROGRESS
                    }
                },
                {
                    path: PATHNAME.FARE_RULE_ALL,
                    name: COMPONENT_NAME.FARE_RULE_ALL,
                    component: FareRuleAll,

                    meta: {
                        progress: UI_CONTROL.PROGRESS
                    }
                },
                {
                    path: PATHNAME.FARE_UPLOAD_NEW,
                    name: COMPONENT_NAME.FARE_UPLOAD_NEW,
                    component: FareUploadNew,

                    meta: {
                        progress: UI_CONTROL.PROGRESS
                    }
                },
                {
                    path: PATHNAME.FARE_UPLOAD_ALL,
                    name: COMPONENT_NAME.FARE_UPLOAD_ALL,
                    component: FareUploadAll,

                    meta: {
                        progress: UI_CONTROL.PROGRESS
                    }
                },
                {
                    path: PATHNAME.SCHEDULE_NEW,
                    name: COMPONENT_NAME.SCHEDULE_NEW,
                    component: ScheduleNew,

                    meta: {
                        progress: UI_CONTROL.PROGRESS
                    }
                },
                {
                    path: PATHNAME.SCHEDULE_ALL,
                    name: COMPONENT_NAME.SCHEDULE_ALL,
                    component: ScheduleAll,

                    meta: {
                        progress: UI_CONTROL.PROGRESS
                    }
                },
                {
                    path: PATHNAME.CONTRACT_ALL,
                    name: COMPONENT_NAME.CONTRACT_ALL,
                    component: ContractAll,

                    meta: {
                        progress: UI_CONTROL.PROGRESS
                    }
                },
          
                {
                    path: PATHNAME.CONTRACT_NEW,
                    name: COMPONENT_NAME.CONTRACT_NEW,
                    component: ContractNew,

                    meta: {
                        progress: UI_CONTROL.PROGRESS
                    }
                },
                {
                    path: PATHNAME.TAX_ALL,
                    name: COMPONENT_NAME.TAX_ALL,
                    component: TaxAll,

                    meta: {
                        progress: UI_CONTROL.PROGRESS
                    }
                },
                {
                    path: PATHNAME.BOOKING_MANIFEST_REPORT,
                    name: COMPONENT_NAME.C_BOOKING_MANIFEST_REPORT,
                    component: BookingManifestReport,
                    meta: {
                        progress: UI_CONTROL.PROGRESS
                    }
                },
                {
                    path: PATHNAME.BOOKING_LIST_REPORT,
                    name: COMPONENT_NAME.C_BOOKING_LIST_REPORT,
                    component: BookingListReport,
                    meta: {
                        progress: UI_CONTROL.PROGRESS
                    }
                },
                {
                    path: PATHNAME.FLIGHT_LOAD_FACTOR_REPORT,
                    name: COMPONENT_NAME.C_FLIGHT_LOAD_FACTOR_REPORT,
                    component: FlightLoadFactorReport,
                    meta: {
                        progress: UI_CONTROL.PROGRESS
                    }
                },
                {
                    path: PATHNAME.AGENTGROUP_ALL,
                    name: COMPONENT_NAME.AGENTGROUP_ALL,
                    component: AgentGroupAll,

                    meta: {
                        progress: UI_CONTROL.PROGRESS
                    }
                },
                {
                    path: PATHNAME.AGENTGROUP_NEW,
                    name: COMPONENT_NAME.AGENTGROUP_NEW,
                    component: AgentGroupNew,

                    meta: {
                        progress: UI_CONTROL.PROGRESS
                    }
                },

            {
                path: PATHNAME.PENDING_PAY,
                name: COMPONENT_NAME.PENDING_PAY,
                component: PendingPay,

                meta: {
                    progress: UI_CONTROL.PROGRESS
                }
            },
            {
                path: PATHNAME.FAILED_PAY,
                name: COMPONENT_NAME.FAILED_PAY,
                component: FailedPay,

                meta: {
                    progress: UI_CONTROL.PROGRESS
                }
            },
            {
                path: PATHNAME.SUCCESS_PAY,
                name: COMPONENT_NAME.SUCCESS_PAY,
                component: SuccessPay,

                meta: {
                    progress: UI_CONTROL.PROGRESS
                }
            },
            {
                path: PATHNAME.PAYMENT_STATUS,
                name: COMPONENT_NAME.PAYMENT_STATUS,
                component: PaymentStatus,

                meta: {
                    progress: UI_CONTROL.PROGRESS
                }
            },
            {
                path: PATHNAME.TICKET_NOW,
                name: COMPONENT_NAME.TICKET_NOW,
                component: TicketNow,

                meta: {
                    progress: UI_CONTROL.PROGRESS
                }
            },
            {
                path: PATHNAME.SYSTEM_TICKET_NOW,
                name: COMPONENT_NAME.SYSTEM_TICKET_NOW,
                component: SystemTicketNow,

                meta: {
                    progress: UI_CONTROL.PROGRESS
                }
            },
            {
                path: PATHNAME.ADD_PROFILE,
                name: COMPONENT_NAME.ADD_PROFILE,
                component: AddProfile,

                meta: {
                    progress: UI_CONTROL.PROGRESS
                }
            },
            {
                path: PATHNAME.PROFILE_LIST,
                name: COMPONENT_NAME.PROFILE_LIST,
                component: ProfileList,

                meta: {
                    progress: UI_CONTROL.PROGRESS
                }
            },
            {
                path: PATHNAME.PAYMENT_RECEIVED,
                name: COMPONENT_NAME.PAYMENT_RECEIVED,
                component: PaymentReceived,

                meta: {
                    progress: UI_CONTROL.PROGRESS
                }
            },
            {
                path: PATHNAME.SUCCESSPAGE,
                name: COMPONENT_NAME.SUCCESSPAGE,
                component: SuccessPage,

                meta: {
                    progress: UI_CONTROL.PROGRESS
                }
            },
            {
                path: PATHNAME.PENDINGPAGE,
                name: COMPONENT_NAME.PENDINGPAGE,
                component: PendingPage,

                meta: {
                    progress: UI_CONTROL.PROGRESS
                }
            },
            {
                path: PATHNAME.FAILEDPAGE,
                name: COMPONENT_NAME.FAILEDPAGE,
                component: FailedPage,

                meta: {
                    progress: UI_CONTROL.PROGRESS
                }
            },
            {
                path: PATHNAME.HOLDPAGE,
                name: COMPONENT_NAME.HOLDPAGE,
                component: HoldPage,

                meta: {
                    progress: UI_CONTROL.PROGRESS
                }
            },
            {
                path: PATHNAME.MY_BOOKING_DETAIL,
                name: COMPONENT_NAME.MY_BOOKING_DETAIL,
                component: MyBookingDetail,

                meta: {
                    progress: UI_CONTROL.PROGRESS
                }
            },
            {
                path: PATHNAME.TICKETING_QUEUE_DETAIL,
                name: COMPONENT_NAME.TICKETING_QUEUE_DETAIL,
                component: TicketingQueueDetail,

                meta: {
                    progress: UI_CONTROL.PROGRESS
                }
            },






            {
                path: PATHNAME.BOOKING_DETAILS,
                name: COMPONENT_NAME.BOOKING_DETAILS,
                component: BookingDetails,

                meta: {
                    progress: UI_CONTROL.PROGRESS
                }
            },

            {
                path: PATHNAME.PAXPAGE,

                name: COMPONENT_NAME.PAXPAGE,
                component: PaxPage,
                meta: {
                    progress: UI_CONTROL.PROGRESS
                }
            },
            {
                path: PATHNAME.GUEST_PAGE,

                name: COMPONENT_NAME.GUEST_PAGE,
                component: GuestPage,
                meta: {
                    progress: UI_CONTROL.PROGRESS
                }
            },
            {
                path: PATHNAME.HOTEL_PAYMENT_PAGE,

                name: COMPONENT_NAME.HOTEL_PAYMENT_PAGE,
                component: HotelPaymentPage,
                meta: {
                    progress: UI_CONTROL.PROGRESS
                }
            },
            {
                path: PATHNAME.PAYMENTPAGE,
                name: COMPONENT_NAME.PAYMENTPAGE,
                component: PaymentPage,

                meta: {
                    progress: UI_CONTROL.PROGRESS
                }
            },
            {
                path: PATHNAME.FLIGHTSEARCH,
                name: COMPONENT_NAME.SEARCHPAGE,
                component: SearchPage,

                meta: {
                    progress: UI_CONTROL.PROGRESS
                }
            },
            {
                path: PATHNAME.BOOKING,
                redirect: PATHNAME.MY_BOOKING,
                name: COMPONENT_NAME.MY_BOOKING,

                component: {
                    render(c) {
                        return c("router-view");
                    }
                },
                children: [{
                    path: PATHNAME.MY_BOOKING,
                    name: COMPONENT_NAME.MY_BOOKING,
                    component: MyBookingPage,

                    meta: {
                        progress: UI_CONTROL.PROGRESS
                    }
                },
                {
                    path: PATHNAME.TICKETING_QUEUE,
                    name: COMPONENT_NAME.TICKETING_QUEUE,
                    component: TicketingQueuePage,

                    meta: {
                        progress: UI_CONTROL.PROGRESS
                    }
                },
                {
                    path: PATHNAME.ALL_REFUND,
                    name: COMPONENT_NAME.ALL_REFUND,
                    component: AllRefund,

                    meta: {
                        progress: UI_CONTROL.PROGRESS
                    }
                },
                {
                    path: PATHNAME.REFUND_DET,
                    name: COMPONENT_NAME.REFUND_DET,
                    component: RefundDet,

                    meta: {
                        progress: UI_CONTROL.PROGRESS
                    }
                },


                {
                    path: PATHNAME.ALL_EXCHANGE,
                    name: COMPONENT_NAME.ALL_EXCHANGE,
                    component: AllExchange,

                    meta: {
                        progress: UI_CONTROL.PROGRESS
                    }
                },
                {
                    path: PATHNAME.EXCHANGE_DET,
                    name: COMPONENT_NAME.EXCHANGE_DET,
                    component: ExchangeDet,

                    meta: {
                        progress: UI_CONTROL.PROGRESS
                    }
                },



                ]
            },
            {
                path: PATHNAME.FLIGHTRESULTS,
                name: COMPONENT_NAME.FLIGHTRESULTS,
                component: FlightResults,

                meta: {
                    progress: UI_CONTROL.PROGRESS
                }
            },
            {
                path: PATHNAME.TEST_FLIGHT_RESULTS,
                name: COMPONENT_NAME.TEST_FLIGH_RESULTS,
                component: TestFlightResults,

                meta: {
                    progress: UI_CONTROL.PROGRESS
                }
            },
            {
                path: PATHNAME.HOTEL_RESULT,
                name: COMPONENT_NAME.HOTEL_RESULTS,
                component: HotelResult,

                meta: {
                    progress: UI_CONTROL.PROGRESS
                }
            },
            {
                path: PATHNAME.HOTEL_ROOM_RESULT,
                name: COMPONENT_NAME.HOTEL_ROOM_RESULTS,
                component: HotelRoomResult,

                meta: {
                    progress: UI_CONTROL.PROGRESS
                }
            },
            {
                path: PATHNAME.SUPPLIER_GROUP_ALL,
                name: COMPONENT_NAME.SUPPLIER_GROUP_ALL,
                component: SupplierGroupAll,

                meta: {
                    progress: UI_CONTROL.PROGRESS
                }
            },
            {
                path: PATHNAME.SUPPLIER_GROUP_NEW,
                name: COMPONENT_NAME.SUPPLIER_GROUP_NEW,
                component: SupplierGroupNew,

                meta: {
                    progress: UI_CONTROL.PROGRESS
                }
            },
            {
                path: PATHNAME.MANAGE_ALL,
                name: COMPONENT_NAME.MANAGE_ALL,
                component: ManageAll,

                meta: {
                    progress: UI_CONTROL.PROGRESS
                }
            },
            {
                path: PATHNAME.HOTEL_INFO,
                name: COMPONENT_NAME.HOTEL_INFO,
                component: HotelInfo,
                meta: {
                    progress: UI_CONTROL.PROGRESS
                }
            },
            {
                path: PATHNAME.MANAGE_HOTEL_NEW,
                name: COMPONENT_NAME.MANAGE_HOTEL_NEW,
                component: ManageHotelNew,
                meta: {
                    progress: UI_CONTROL.PROGRESS
                }
            },
            {
                path: PATHNAME.TARIFF_ALL,
                name: COMPONENT_NAME.TARIFF_ALL,
                component: TariffAll,
                meta: {
                    progress: UI_CONTROL.PROGRESS
                }
            },
            {
                path: PATHNAME.CANCELLATION_ALL,
                name: COMPONENT_NAME.CANCELLATION_ALL,
                component: CancellationAll,
                meta: {
                    progress: UI_CONTROL.PROGRESS
                }
            },
            {
                path: PATHNAME.RATE_PLAN_ALL,
                name: COMPONENT_NAME.RATE_PLAN_ALL,
                component: RatePlanAll,
                meta: {
                    progress: UI_CONTROL.PROGRESS
                }
            },
            {
                path: PATHNAME.SURCHARGE_ALL,
                name: COMPONENT_NAME.SURCHARGE_ALL,
                component: SurchargeAll,
                meta: {
                    progress: UI_CONTROL.PROGRESS
                }
            },
            {
                path: PATHNAME.MARKUP_ALL,
                name: COMPONENT_NAME.MARKUP_ALL,
                component: MarkupAll,
                meta: {
                    progress: UI_CONTROL.PROGRESS
                }
            },
            {
                path: PATHNAME.MARKUP_NEW,
                name: COMPONENT_NAME.MARKUP_NEW,
                component: MarkupNew,
                meta: {
                    progress: UI_CONTROL.PROGRESS
                }
            },
           
            {
                path: PATHNAME.TARIFF_NEW,
                name: COMPONENT_NAME.TARIFF_NEW,
                component: TariffNew,
                meta: {
                    progress: UI_CONTROL.PROGRESS
                }
            },
            {
                path: PATHNAME.CANCELLATION_NEW,
                name: COMPONENT_NAME.CANCELLATION_NEW,
                component: CancellationNew,
                meta: {
                    progress: UI_CONTROL.PROGRESS
                }
            },
            {
                path: PATHNAME.RATE_PLAN_NEW ,
                name: COMPONENT_NAME.RATE_PLAN_NEW,
                component: RatePlanNew,
                meta: {
                    progress: UI_CONTROL.PROGRESS
                }
            },
            {
                path: PATHNAME.SURCHARGE_NEW,
                name: COMPONENT_NAME.SURCHARGE_NEW,
                component: SurchargeNew,
                meta: {
                    progress: UI_CONTROL.PROGRESS
                }
            },

            {
                path: PATHNAME.HOTEL_TAX_NEW,
                name:COMPONENT_NAME.HOTEL_TAX_NEW,
                component :HotelTaxNew,
                meta: {
                    progress: UI_CONTROL.PROGRESS
                }

            },
            {
                path: PATHNAME.HOTEL_ROOM_SETUP,
                name:COMPONENT_NAME.HOTEL_ROOM_SETUP,
                component :HotelRoomSetup,
                meta: {
                    progress: UI_CONTROL.PROGRESS
                },
          

            },

            {
                path: PATHNAME.HOTEL_USERS_ALL,
                name:COMPONENT_NAME.HOTEL_USERS_ALL,
                component :HotelUsersAll,
                meta: {
                    progress: UI_CONTROL.PROGRESS
                }
            },
            {
                path: PATHNAME.HOTEL_USERS_NEW,
                name:COMPONENT_NAME.HOTEL_USERS_NEW,
                component :HotelUserNew,
                meta: {
                    progress: UI_CONTROL.PROGRESS
                }

            },
            {
                path:PATHNAME.ALL_HOTEL_TAX_SETUP,
                name:COMPONENT_NAME.ALL_HOTEL_TAX_SETUP,
                component :AllHotelTaxSetup,
                meta: {
                    progress: UI_CONTROL.PROGRESS
                }

            },














            // {  path: PATHNAME.MANAGE_NEW,
            //          name: COMPONENT_NAME.MANAGE_NEW,
            //      component: ManageNew,
            //     meta: {
            //         progress: UI_CONTROL.PROGRESS
            //     }
            // },
            {
                path: PATHNAME.TOUR_FLIGHT_RESULTS,
                name: COMPONENT_NAME.TOUR_FLIGHT_RESULTS,
                component: TourFlightResults,

                meta: {
                    progress: UI_CONTROL.PROGRESS
                }
            },
            {
                path: PATHNAME.TOUR_ML_FLIGHT_RESULTS,
                name: COMPONENT_NAME.TOUR_ML_FLIGHT_RESULTS,
                component: TourMLFlightResult,

                meta: {
                    progress: UI_CONTROL.PROGRESS
                }
            },
            {
                path: PATHNAME.ML_FLIGHTRESULTS,
                name: COMPONENT_NAME.ML_FLIGHTRESULTS,
                component: MLFlightResults,

                meta: {
                    progress: UI_CONTROL.PROGRESS
                }
            },
          

            {
                path: PATHNAME.ROUTE,
                name: COMPONENT_NAME.ROUTE,
                component: Route
            },
            {
                path: PATHNAME.SYSTEM_TOPUP,
                name: COMPONENT_NAME.SYSTEM_TOPUP,
                component: SystemTopUp
            },
            {
                path: PATHNAME.TOPUP_REPORT,
                name: COMPONENT_NAME.TOPUP_REPORT,
                component: TopupReport
            },
            {
                path: PATHNAME.TOPUP,
                name: COMPONENT_NAME.TOPUP,
                component: TopUp
            },

            {
                path: PATHNAME.DASHBOARD,
                name: COMPONENT_NAME.DASHBOARD,
                component: Dashboard
            },
            {
                path: PATHNAME.EXCHANGE_RATE,
                name: COMPONENT_NAME.EXCHANGE_RATE,
                component: ExchangeRate,
                meta: {
                    progress: UI_CONTROL.PROGRESS
                }
            },
          

            {
                path: PATHNAME.REPORT,
                name: COMPONENT_NAME.REPORT,
                component: Report,
                meta: {
                    progress: UI_CONTROL.PROGRESS
                }
            },

            {
                path: PATHNAME.SYSTEM_REPORT,
                name: COMPONENT_NAME.SYSTEM_REPORT,
                component: SystemReport,
                meta: {
                    progress: UI_CONTROL.PROGRESS
                }
            },
            {
                path: PATHNAME.AGENT_PREPAID_REPORT,
                name: COMPONENT_NAME.AGENT_PREPAID_REPORT,
                component: AgentPrepaidReport,
                meta: {
                    progress: UI_CONTROL.PROGRESS
                }
            },
            {
                path: PATHNAME.AGENT_PREPAID_SUMMARY,
                name: COMPONENT_NAME.AGENT_PREPAID_SUMMARY,
                component: AgentPrepaidSummary,
                meta: {
                    progress: UI_CONTROL.PROGRESS
                }
            },
            {
                path: PATHNAME.AGENT_POSTPAID_REPORT,
                name: COMPONENT_NAME.AGENT_POSTPAID_REPORT,
                component: AgentPostpaidReport,
                meta: {
                    progress: UI_CONTROL.PROGRESS
                }
            },
            {
                path: PATHNAME.AGENT_POSTPAID_SUMMARY,
                name: COMPONENT_NAME.AGENT_POSTPAID_SUMMARY,
                component: AgentPostpaidSummary,
                meta: {
                    progress: UI_CONTROL.PROGRESS
                }
            },
            {
                path: PATHNAME.TOPUP_FORECAST_REPORT,
                name: COMPONENT_NAME.TOPUP_FORECAST_REPORT,
                component: TopupForecastReport,
                meta: {
                    progress: UI_CONTROL.PROGRESS
                }
            },
            {
                path: PATHNAME.DAILY_OR_PERIODICAL_SALES_REPORT,
                name: COMPONENT_NAME.DAILY_OR_PERIODICAL_SALES_REPORT,
                component: DailyOrPeriodicalSalesReport,
                meta: {
                    progress: UI_CONTROL.PROGRESS
                }
            },
            {
                path: PATHNAME.PERIODICAL_SALES_DETAIL_REPORT,
                name: COMPONENT_NAME.PERIODICAL_SALES_DETAIL_REPORT,
                component: DetailReport,
                meta: {
                    progress: UI_CONTROL.PROGRESS
                }
            },
            {
                path: PATHNAME.TOPUP_PROJECTION_REPORT,
                name: COMPONENT_NAME.TOPUP_PROJECTION_REPORT,
                component: TopupProjectionReport,
                meta: {
                    progress: UI_CONTROL.PROGRESS
                }
            },
            {
                path: PATHNAME.CREDIT_SALES_REPORT,
                name: COMPONENT_NAME.CREDIT_SALES_REPORT,
                component: CreditSalesReport,
                meta: {
                    progress: UI_CONTROL.PROGRESS
                }
            },
            {
                path: PATHNAME.BOOKING_REPORT,
                name: COMPONENT_NAME.BOOKING_REPORT,
                component: BookingReport,
                meta: {
                    progress: UI_CONTROL.PROGRESS
                }
            },
            {
                path: PATHNAME.REFUND,
                name: COMPONENT_NAME.REFUND,
                component:Refund,

                meta: {
                    progress: UI_CONTROL.PROGRESS
                }
            },

            {
                path: PATHNAME.EXCHANGE,
                name: COMPONENT_NAME.EXCHANGE,
                component:Exchange,

                meta: {
                    progress: UI_CONTROL.PROGRESS
                }
            },

            {
                path: PATHNAME.USERS,
                redirect: PATHNAME.MANAGE_USERS,
                name: COMPONENT_NAME.USERS,

                component: {
                    render(c) {
                        return c("router-view");
                    }
                },
                children: [{
                    path: PATHNAME.MANAGE_USERS,
                    name: COMPONENT_NAME.MANAGE_USERS,
                    component: ManageUsers,

                    meta: {
                        progress: UI_CONTROL.PROGRESS
                    }
                },
                {
                    path: PATHNAME.ROLES_PERMISSIONS,
                    name: COMPONENT_NAME.ROLES_PERMISSIONS,
                    component: RolesPermissions,

                    meta: {
                        progress: UI_CONTROL.PROGRESS
                    }
                },
                {
                    path: PATHNAME.ADD_USER,
                    name: COMPONENT_NAME.ADD_USER,
                    component: AddUser,

                    meta: {
                        progress: UI_CONTROL.PROGRESS
                    }
                },

                {
                    path: PATHNAME.USER_STATUS,
                    name: COMPONENT_NAME.USER_STATUS,
                    component: UserStatus,

                    meta: {
                        progress: UI_CONTROL.PROGRESS
                    }
                },
                {
                    path: PATHNAME.CHANGE_PASSWORD,
                    name: COMPONENT_NAME.CHANGE_PASSWORD,
                    component: ChangePassword,

                    meta: {
                        progress: UI_CONTROL.PROGRESS
                    }
                }
                ]
            },

            {
                path: PATHNAME.TOOLS,
                redirect: PATHNAME.EXCHANGE_RATE,
                name: COMPONENT_NAME.TOOLS,
                component: {
                    render(c) {
                        return c("router-view");
                    }
                },
                children: [{
                    path: PATHNAME.CLASSES,
                    name: COMPONENT_NAME.CLASSES,
                    component: Classes,
                    meta: {
                        progress: UI_CONTROL.PROGRESS
                    }
                }, {
                    path: PATHNAME.ROUTES,
                    name: COMPONENT_NAME.ROUTES,
                    component: Routes,
                    meta: {
                        progress: UI_CONTROL.PROGRESS
                    }
                },
                {
                    path: PATHNAME.PAYMENT_SETUP,
                    name: COMPONENT_NAME.PAYMENT_SETUP,
                    component: PaymentSetup,
                    meta: {
                        progress: UI_CONTROL.PROGRESS
                    }
                },
                {
                    path: PATHNAME.NOTIFICATION_SETUP,
                    name: COMPONENT_NAME.NOTIFICATION_SETUP,
                    component: NotificationSetUp,
                    meta: {
                        progress: UI_CONTROL.PROGRESS
                    }
                },
           


              

                {
                    path: PATHNAME.ADD_PAYMENT,
                    name: COMPONENT_NAME.ADD_PAYMENT,
                    component: AddPayment,
                    meta: {
                        progress: UI_CONTROL.PROGRESS
                    }
                },
                {
                    path: PATHNAME.PAYMENT_FEE,
                    name: COMPONENT_NAME.PAYMENT_FEE,
                    component: PaymentFee,
                    meta: {
                        progress: UI_CONTROL.PROGRESS
                    }
                },
                {
                    path: PATHNAME.CURRENCY,
                    name: COMPONENT_NAME.CURRENCY,
                    component: Currency,
                    meta: {
                        progress: UI_CONTROL.PROGRESS
                    }
                },
                {
                    path: PATHNAME.STATE_PROVINCE,
                    name: COMPONENT_NAME.STATE_PROVINCE,
                    component: StateProvince,
                    meta: {
                        progress: UI_CONTROL.PROGRESS
                    }
                },
                {
                    path: PATHNAME.EXTENSION_SETUP,
                    name: COMPONENT_NAME.EXTENSION_SETUP,
                    component: ExtensionSetUp,
                    meta: {
                        progress: UI_CONTROL.PROGRESS
                    }
                }
                ]
            },

            {
                path: PATHNAME.PRICING,
                redirect: PATHNAME.SETUP_PRICING,
                name: COMPONENT_NAME.PRICING,
                component: {
                    render(c) {
                        return c("router-view");
                    }
                },
                children: [{
                    path: PATHNAME.SETUP_PRICING,
                    name: COMPONENT_NAME.SETUP_PRICING,
                    component: SetupPricing,
                    meta: {
                        progress: UI_CONTROL.PROGRESS
                    }
                },
                {
                    path: PATHNAME.CREATE_PRICING,
                    name: COMPONENT_NAME.CREATE_PRICING,
                    component: CreatePricing,
                    meta: {
                        progress: UI_CONTROL.PROGRESS
                    }
                },

                {
                    path: PATHNAME.MANAGE_PRICING,
                    name: COMPONENT_NAME.MANAGE_PRICING,
                    component: ManagePricing,
                    meta: {
                        progress: UI_CONTROL.PROGRESS
                    }
                },

                {
                    path: PATHNAME.MANAGE_SIMPLE_PRICING,
                    name: COMPONENT_NAME.MANAGE_SIMPLE_PRICING,
                    component: ManageSimplePricing,
                    meta: {
                        progress: UI_CONTROL.PROGRESS
                    }
                },
                
                {
                    path: PATHNAME.CREATE_SIMPLE_PRICING,
                    name: COMPONENT_NAME.CREATE_SIMPLE_PRICING,
                    component: CreateSimplePricing,
                    meta: {
                        progress: UI_CONTROL.PROGRESS
                    }
                },
                {
                    path: PATHNAME.ASSIGN_PRICING,
                    name: COMPONENT_NAME.ASSIGN_PRICING,
                    component: AssignPricing,
                    meta: {
                        progress: UI_CONTROL.PROGRESS
                    }
                },
                {
                    path: PATHNAME.ADD_NEW_PRICING,
                    name: COMPONENT_NAME.ADD_NEW_PRICING,
                    component: AddNewPricing,
                    meta: {
                        progress: UI_CONTROL.PROGRESS
                    }
                }
                ]
            },
            {
                path: PATHNAME.APPROVE_AGENT,
                name: COMPONENT_NAME.APPROVE_AGENT,
                component: ApproveAgent,
                meta: {
                    progress: UI_CONTROL.PROGRESS
                }
            },
            {
                path: PATHNAME.MANAGE_AGENT,
                name: COMPONENT_NAME.MANAGE_AGENT,
                component: ManageAgent,
                meta: {
                    progress: UI_CONTROL.PROGRESS
                }
            },
            {
                path: PATHNAME.MANAGE,
                name: COMPONENT_NAME.MANAGE,
                component: Manage,
                 meta: {
                        progress: UI_CONTROL.PROGRESS
                    }
            },
            // {
            //     path: PATHNAME.AGENT_REGISTRATION,
            //     redirect: PATHNAME.APPROVE_AGENT,
            //     name: COMPONENT_NAME.AGENT_REGISTRATION,
            //     component: {
            //         render(c) {
            //             return c("router-view");
            //         }
            //     },
            //     children: [{
            //         path: PATHNAME.APPROVE_AGENT,
            //         name: COMPONENT_NAME.APPROVE_AGENT,
            //         component: ApproveAgent
            //     },
            //     {
            //         path: PATHNAME.MANAGE_AGENT,
            //         name: COMPONENT_NAME.MANAGE_AGENT,
            //         component: ManageAgent
            //     },
            //     {
            //         path: PATHNAME.MANAGE,
            //         name: COMPONENT_NAME.MANAGE,
            //         component: Manage
            //     },
            //     ]
            // },

            {
                path: PATHNAME.POSTPAID,
                redirect: PATHNAME.DEPOSIT,
                name: "postpaid",
                component: {
                    render(c) {
                        return c("router-view");
                    }
                },
                children: [{
                    path: PATHNAME.DEPOSIT,
                    name: COMPONENT_NAME.DEPOSIT,
                    component: Deposit,
                    meta: {
                        progress: UI_CONTROL.PROGRESS
                    }
                },
                {
                    path: PATHNAME.AGENT_DEPOSIT_PAY,
                    name: COMPONENT_NAME.AGENT_DEPOSIT_PAY,
                    component: AgentDepositPay,
                    meta: {
                        progress: UI_CONTROL.PROGRESS
                    }
                },

                {
                    path: PATHNAME.AGENT_DEPOSIT,
                    name: COMPONENT_NAME.AGENT_DEPOSIT,
                    component: AgentDeposit,
                    meta: {
                        progress: UI_CONTROL.PROGRESS
                    }
                },
                {
                    path: PATHNAME.AGENT_VIEW_STATEMENTS,
                    name: COMPONENT_NAME.AGENT_VIEW_STATEMENTS,
                    component: AgentViewStatements,
                    meta: {
                        progress: UI_CONTROL.PROGRESS
                    }
                },
                {
                    path: PATHNAME.PENDING_INVOICES,
                    name: COMPONENT_NAME.PENDING_INVOICES,
                    component: PendingInvoices,
                    meta: {
                        progress: UI_CONTROL.PROGRESS
                    }
                },
                {
                    path: PATHNAME.VIEW_STATEMENTS,
                    name: COMPONENT_NAME.VIEW_STATEMENTS,
                    component: ViewStatements,
                    meta: {
                        progress: UI_CONTROL.PROGRESS
                    }
                },
                ]
            },

            {
                path: PATHNAME.CREDIT_NOTE,
                redirect: PATHNAME.CREDIT,
                name: COMPONENT_NAME.CREDIT,
                component: {
                    render(c) {
                        return c("router-view");
                    }
                },
                children: [{
                    path: PATHNAME.CREDIT,
                    name: COMPONENT_NAME.CREDIT,
                    component: Credit
                },
                {
                    path: PATHNAME.CREDIT_REPORT,
                    name: COMPONENT_NAME.CREDIT_REPORT,
                    component: CreditReport
                }
                ]
            },
            {
                path: PATHNAME.DEBIT,
                redirect: PATHNAME.DEBIT_NOTE,
                name: COMPONENT_NAME.TOOLS,
                component: {
                    render(c) {
                        return c("router-view");
                    }
                },
                children: [{
                    path: PATHNAME.DEBIT_NOTE,
                    name: COMPONENT_NAME.DEBIT_NOTE,
                    component: DebitNote
                },
                {
                    path: PATHNAME.DEBIT_REPORT,
                    name: COMPONENT_NAME.DEBIT_REPORT,
                    component: DebitReport
                }
                ]
            },
            {
                path: PATHNAME.BOOKING_STATUS,
                name: COMPONENT_NAME.BOOKING_STATUS_PAGE,
                component: BookingStatusPage,

                meta: {
                    progress: UI_CONTROL.PROGRESS
                }
            },
            {
                path: PATHNAME.APROFILE,
                name: COMPONENT_NAME.APROFILE,
                component: aProfile
            },

            ]
        },
        {
            path: PATHNAME.PAGES,
            redirect: PATHNAME.PAGE_404,
            name: COMPONENT_NAME.PAGES,
            component: {
                render(c) {
                    return c("router-view");
                }
            },
            children: [{
                path: PATHNAME.PAGE_404,
                name: COMPONENT_NAME.PAGE_404,
                component: Page404
            },
            {
                path: PATHNAME.PAGE_500,
                name: COMPONENT_NAME.PAGE_500,
                component: Page500
            }

            ]
        },
        {
            path: PATHNAME.GUIDE,
            name: COMPONENT_NAME.GUIDE,
            component: Guide,

            meta: {
                progress: UI_CONTROL.PROGRESS
            }
        },
        {
            path: PATHNAME.AGENT_REGISTRATION,
            name: COMPONENT_NAME.AGENT_REGISTRATION,
            component: AgentRegistration,

            meta: {
                progress: UI_CONTROL.PROGRESS
            }
        },
        {
            path: PATHNAME.AGENT_LOGIN,
            name: COMPONENT_NAME.AGENT_LOGIN,
            component: AgentLogin,

            meta: {
                progress: UI_CONTROL.PROGRESS
            }
        },
        {
            path: PATHNAME.SYSTEM_LOGIN,
            name: COMPONENT_NAME.SYSTEM_LOGIN,
            component: SystemLogin,

            meta: {
                progress: UI_CONTROL.PROGRESS
            }
        },
        {
            path: PATHNAME.RESET_PASSWORD,
            name: COMPONENT_NAME.RESET_PASSWORD,
            component: ResetPassword,

            meta: {
                progress: UI_CONTROL.PROGRESS
            }
        },
            // {
            //     path: PATHNAME.HOME,
            //     name: COMPONENT_NAME.HOME,
            //     component: Home,

            //     meta: {
            //         progress: UI_CONTROL.PROGRESS
            //     }
            // },







        ];
    } catch (err) {
        if (navigator.onLine) {
            let body = Logger.buildRequest(
                FILE_NAME.ROUTER,
                "error in config Routes",
                err.toString(),
                "configRoutes()",
                LOG_TYPE.ERROR
            );

            Logger.getResponse(body);
        }
    }
}

function clearLocalStorage() {
    try {
        if (BaseConfiguration.isDebug) console.log("clearLocalStorage");
        clearLogCountFromLocal()
        clearAgtLoginResFromLocal()
        clearSysLoginResFromLocal()
        clearBaseSettFromLocal()


    } catch (err) {
        let body = Logger.buildRequest(
            FILE_NAME.ROUTER,
            "error in Clear Local Storage",
            err.toString(),
            "clearLocalStorage()",
            LOG_TYPE.ERROR
        );

        Logger.getResponse(body);
    }
}



export async function updateCurrRouteQuery(pQuery) {
    try {
        if (BaseConfiguration.isDebug) console.log("updateCurrRouteQuery");
        if(Router.currentRoute){
            await Router.replace({
                ...Router.currentRoute,
                query: pQuery
            }).catch(err => {
                    throw err;
                });
            }else{
                throw 'invalid current route'
            }
    
      
    } catch (err) {
        let body = Logger.buildRequest(
            FILE_NAME.ROUTER,
            "error in update Curr Route Query",
            err.toString(),
            "updateCurrRouteQuery()",
            LOG_TYPE.ERROR
        );

        Logger.getResponse(body);
    }
}

export function goBack(param) {
    try {
        if (BaseConfiguration.isDebug) console.log("goBack");
        if (param) {
            Router.go(param);
        } else {
            Router.go(-1);
        }
    } catch (err) {
        let body = Logger.buildRequest(
            FILE_NAME.ROUTER,
            "error in go Back",
            err.toString(),
            "goBack()",
            LOG_TYPE.ERROR
        );

        Logger.getResponse(body);
    }
}

export function navigateReplace(pRouteName, pQuery) {
    try {
        if (BaseConfiguration.isDebug) console.log("navigateReplace");
        let route = {
            path: pRouteName,

        };
        if (pQuery) {
            route.query = pQuery;

        }

        if (pRouteName) {

            Router.replace(route).catch(err => {
                throw err;
            })
        } else {

            throw "invalid Route Name";
        }
    } catch (err) {
        let body = Logger.buildRequest(
            FILE_NAME.ROUTER,
            "error in navigateReplace To",
            err.toString(),
            "navigateReplace()",
            LOG_TYPE.ERROR
        );

        Logger.getResponse(body);
    }
}



export function navigate(pRouteName, pQuery) {
    try {
        if (BaseConfiguration.isDebug) console.log("navigate");

        let route = {
            path: pRouteName,

        };
        if (pQuery) {
            route.query = pQuery;

        }

        if (pRouteName) {

            Router.push(route).catch(err => {
                // throw err;
            })
        } else {

            throw "invalid Route Name";
        }
    } catch (err) {
        let body = Logger.buildRequest(
            FILE_NAME.ROUTER,
            "error in navigate To",
            err.toString(),
            "navigateTo()",
            LOG_TYPE.ERROR
        );

        Logger.getResponse(body);
    }
}

export function reloadCurrentPage() {
    try {
        if (BaseConfiguration.isDebug) console.log("reloadCurrentPage");
        Router.go();

    } catch (err) {
        let body = Logger.buildRequest(
            FILE_NAME.UTIL,
            "error in reloadCurrentPage",
            err.toString(),
            "reloadCurrentPage",
            LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
    }
}

Router.afterEach((to, from, next) => {
    try {
        //  finish the progress bar

        // if (main) {
        //     main.$Progress.finish();
        //     // console.error(main)
        // }
       
        /*   if ((from.path == PATHNAME.PENDINGPAGE || from.path == PATHNAME.HOLDPAGE || from.path == PATHNAME.SUCCESSPAGE || from.path == PATHNAME.FAILEDPAGE) && to.path != PATHNAME.FLIGHTSEARCH) {
              next(PATHNAME.FLIGHTSEARCH)
          }

          if ((from.path == PATHNAME.FLIGHTSEARCH) && (to.path == PATHNAME.PENDINGPAGE || to.path == PATHNAME.HOLDPAGE || to.path == PATHNAME.SUCCESSPAGE || to.path == PATHNAME.FAILEDPAGE || to.path == PATHNAME.PAYMENTPAGE)) {
              next(PATHNAME.DASHBOARD)
          } */


    } catch (err) {
        if (navigator.onLine) {
            let body = Logger.buildRequest(
                FILE_NAME.ROUTER,
                "error in Router.afterEach",
                err.toString(),
                "Router.afterEach()",
                LOG_TYPE.ERROR
            );

            Logger.getResponse(body);
        }
    }
}),

    Router.beforeEach(async (to, from, next) => {
        try {
            // next(vm => vm.resetFocus())
            
                   

            if (getAgentSignInResponse()) {
                document.title = "Agent Portal - B2B Flight Engine"
            } else if (getAdminSignInResponse()) {
                document.title = "System Portal - B2B Flight Engine"
            }
            const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

            async  function getRenew(){
            let renewJWT_status;

            if (!(
                to.path == PATHNAME.HOME ||
                to.path == PATHNAME.AGENT_LOGIN ||
                to.path == PATHNAME.SYSTEM_LOGIN ||
                from.path == PATHNAME.SYSTEM_LOGIN ||
                from.path == PATHNAME.AGENT_LOGIN ||
                to.path == PATHNAME.PAGE_404 ||
                to.path == PATHNAME.PAGE_500 ||
                to.path == PATHNAME.AGENT_REGISTRATION ||
                to.path == PATHNAME.RESET_PASSWORD ||
                from.path == PATHNAME.RESET_PASSWORD ||
                to.path == PATHNAME.HOLDPAGE ||
                to.path == PATHNAME.SUCCESSPAGE ||
                to.path == PATHNAME.PAYMENT_STATUS ||
                to.path == PATHNAME.BOOKING_STATUS ||
                to.path == PATHNAME.FAILEDPAGE ||
                to.path == PATHNAME.PENDINGPAGE ||
                to.path==PATHNAME.GUIDE||

                //to avoid multiple renew #426
                from.path == PATHNAME.BOOKING_STATUS ||  //to avoid multiple renew #426
                from.path == PATHNAME.PAYMENT_STATUS ||//to avoid multiple renew #426
                from.path == PATHNAME.HOLDPAGE ||
                from.path == PATHNAME.SUCCESSPAGE ||
                from.path == PATHNAME.FAILEDPAGE ||
                from.path == PATHNAME.PENDINGPAGE
            )) {
                renewJWT_status = await renewJWT();
            }



            if (renewJWT_status && renewJWT_status.authorization) {
                if (store.getters["sAgtLogin/GET_SIGNIN_RES"]) {
                    let renewJWT = store.getters["sAgtLogin/GET_SIGNIN_RES"];
                    renewJWT.authorization = renewJWT_status.authorization;
                    store.dispatch("sAgtLogin/SET_SIGNIN_RES", renewJWT);
                    // store.dispatch("sAgtLogin/SET_SIGNIN_RES", renewJWT_status);
                } else if (store.getters["sSysLogin/GET_ADMIN_SIGNIN_RES"]) {
                    let renewJWT = store.getters["sSysLogin/GET_ADMIN_SIGNIN_RES"];
                    renewJWT.authorization = renewJWT_status.authorization;
                    store.dispatch("sSysLogin/SET_ADMIN_SIGNIN_RES", renewJWT);
                }
            }

            ///to Start Progress Bar
            // if (to && to.meta && to.meta.progress) {
            //     let meta = to.meta.progress;
            //     if (main) {
            //         main.$Progress.parseMeta(meta);
            //         main.$Progress.start();
            //     }
            // }

            //to Clear All Request , Response and Data in Local store before Login
            if (
                to.path == PATHNAME.HOME ||
                to.path == PATHNAME.AGENT_LOGIN ||
                to.path == PATHNAME.SYSTEM_LOGIN 
              
            ) {

                removeB2BMFfromSession()



                clearLocalStorage();

                Vue.toasted.clear();
                clearStore()


                // EventBus.$emit('clearAllToast',true);




                //Router.history.pending = {};
            }
        }
           assigni18nLocale(checkAndGoNext)
            // if (
            //     store.state.language.language &&
            //     store.state.language.language !== i18n.locale
            // ) {
            //     i18n.locale = store.state.language.language;
            //     checkAndGoNext();
            // } else if (!store.state.language.language) {
            //     // store.dispatch("language/setLanguage", navigator.languages).then(() => {
            //     //     i18n.locale = store.state.language.language;
            //     //     //next();
            //     //     checkAndGoNext();
            //     // });
            //     store.dispatch("language/setLanguage", BaseConfiguration.defaultLanguageCode).then(() => {
            //         i18n.locale = store.state.language.language;
            //         //next();
            //         checkAndGoNext();
            //     });
            // } else {
            //     //next();
            //     checkAndGoNext();
            // }

            function checkAndGoNext() {
                try {
                    // if the page requires authentication and the user is not logged in , then redirect to login page
                    if (requiresAuth) {
                        next({ name: "AgentLogin" });
                       
                        // if(Object.keys(to.query).length)
                        // {
                        //   next({ name:'Login'})
                        // }
                        // else
                        // {
                        //   next({name:'Login'})
                        // }
                    } else {
                        const isBackButton = window.popStateDetected  
                        // if(!Vue.prototype.$isDataEdited){
                        handleBookingFlowNav();
                        // }
                        // if ((from.path == PATHNAME.PENDINGPAGE || from.path == PATHNAME.HOLDPAGE || from.path == PATHNAME.SUCCESSPAGE || from.path == PATHNAME.FAILEDPAGE) 
                        //     && to.path != PATHNAME.FLIGHTSEARCH) {
                        //     next(PATHNAME.FLIGHTSEARCH)
                        // } else if ((from.path == PATHNAME.FLIGHTSEARCH) && (to.path == PATHNAME.PENDINGPAGE || to.path == PATHNAME.HOLDPAGE || to.path == PATHNAME.SUCCESSPAGE || to.path == PATHNAME.FAILEDPAGE || to.path == PATHNAME.PAYMENTPAGE)) {
                        //     next(PATHNAME.DASHBOARD);
                        // }
                        
                        // else if ((from.path == PATHNAME.PENDING_PAY ||  from.path == PATHNAME.SUCCESS_PAY || from.path == PATHNAME.FAILED_PAY&&to.path != PATHNAME.DASHBOARD)) {
                        // next(false);
                        //     next(PATHNAME.DASHBOARD)
                        // }
                        // else if (from.path == PATHNAME.FLIGHTRESULTS && to.path == PATHNAME.ML_FLIGHTRESULTS) {
                        //     next(PATHNAME.FLIGHTSEARCH)
                        // }else if (from.path == PATHNAME.ML_FLIGHTRESULTS && to.path == PATHNAME.FLIGHTRESULTS) {
                        //     next(PATHNAME.FLIGHTSEARCH)
                        // }
                        // else {
                            if(to.path==PATHNAME.REPORT){//to restrict page(old report page)
                                if(Vue.prototype.$isDataEdited){
                                    updateDataEdited(false);
                                }
                                
                                next(PATHNAME.DASHBOARD)
                            }
                           
                           else if (Vue.prototype.$isDataEdited === true) {
                                if(!BaseConfiguration.isEnableDataEditAlert||to.path==PATHNAME.PAGE_404||to.path==PATHNAME.PAGE_500||to.path==PATHNAME.AGENT_LOGIN||to.path==PATHNAME.SYSTEM_LOGIN){
                                    updateDataEdited(false);
                                    next();
                                }else{
                                    getConfirmAndGoNext();

                                }
                            }
                            else {
                                if(BaseConfiguration.isMobile) {
                                        // var AppPageControl = require('@/mobile/containers/aPageControl');
                                        
                                    let isRestrictedRoute = true;
                                    if(AppPageControl) {
                                     isRestrictedRoute = AppPageControl.appRouteControl(to);
                                    }
                                    if(isRestrictedRoute==false){
                                        next(false);
                                    }
                                    else{
                                        next()
                                    }
                            }
                            else{
                                
                                if ((from.path == PATHNAME.PENDINGPAGE || from.path == PATHNAME.HOLDPAGE || from.path == PATHNAME.SUCCESSPAGE || from.path == PATHNAME.FAILEDPAGE) 
                                && to.path != PATHNAME.FLIGHTSEARCH && isBackButton) {
                                next(PATHNAME.FLIGHTSEARCH)
                            } else if (isBackButton && (to.path == PATHNAME.PENDINGPAGE || to.path == PATHNAME.HOLDPAGE || to.path == PATHNAME.SUCCESSPAGE || to.path == PATHNAME.FAILEDPAGE || to.path == PATHNAME.PAYMENTPAGE)) {
                               if(Router.currentRoute.path != PATHNAME.DASHBOARD){
                                next(PATHNAME.DASHBOARD);
                               } else{
                                   next(false);
                               }
                            }else{
                                next();
                            }
                            }
                                
                            }

                        // }
                    }
                } catch (err) {
                    if (navigator.onLine) {
                        let body = Logger.buildRequest(
                            FILE_NAME.ROUTER,
                            "error in checkAndGoNext",
                            err.toString(),
                            "checkAndGoNext()",
                            LOG_TYPE.ERROR
                        );

                        Logger.getResponse(body);
                    }
                }
            }
           if(!Vue.prototype.$isDataEdited
           ){
               if(isCallRenew()){
                await getRenew();
               }
               if(isHmsFlow(to.path)){
                Event.$emit("isHmsFlow", true);
            }else{
               Event.$emit("isHmsFlow", false);
            }
           }
           function isCallRenew(){
               if(BaseConfiguration.isDebug) console.log('isCallRenew')
             if(from.path==to.path){///&&!store.getters["sCMultiCitySearch/GET_IS_MODIFY_SEARCH"]
               return false;
             }else{
               
                 return true;
             }
           }
            
            handleBackFlow();
            
            
            function handleBookingFlowNav() {
                
                const isItABackButton = window.popStateDetected       
                
            if (isItABackButton ) {// && from.meta.someLogica
            // console.error('backbtn',from)
            window.popStateDetected=false;
                 if(!Vue.prototype.$isDataEdited){

          
            // console.error('handleBookingFlowNav', window.popStateDetected)
            if(from.path==PATHNAME.PAXPAGE&&(store.getters["sCMultiCitySearch/GET_IS_ML_SEARCH"]?to.path!=PATHNAME.ML_FLIGHTRESULTS:to.path!=PATHNAME.FLIGHTRESULTS)&&to.path!=PATHNAME.PAYMENTPAGE){
                next(false);
                if(store.getters["sCMultiCitySearch/GET_IS_ML_SEARCH"]){
                    navigate(PATHNAME.ML_FLIGHTRESULTS)
                }else{
                    navigate(PATHNAME.FLIGHTRESULTS)

                }
            }else if(from.path==PATHNAME.FLIGHTRESULTS&&to.path!=PATHNAME.FLIGHTSEARCH&&to.path!=PATHNAME.PAXPAGE&&to.path!=PATHNAME.DASHBOARD){
             next(false);
             navigate(PATHNAME.FLIGHTSEARCH)
            }else if(from.path==PATHNAME.ML_FLIGHTRESULTS&&to.path!=PATHNAME.FLIGHTSEARCH&&to.path!=PATHNAME.PAXPAGE&&to.path!=PATHNAME.DASHBOARD){
                next(false);
                navigate(PATHNAME.FLIGHTSEARCH)
               }

            }
            }
               
            }

            function handleBackFlow() {
                try {
                    if (BaseConfiguration.isDebug) console.log("handleBackFlow");
                
                 if(!Vue.prototype.$isDataEdited){
                   
                    // this.$root.$on("clearAllToast");
                    if (from.path == PATHNAME.BOOKING_STATUS) {
                        if (to.path == PATHNAME.PAYMENTPAGE || to.path == PATHNAME.PAXPAGE || to.path == PATHNAME.FLIGHTRESULTS || to.path == PATHNAME.FLIGHTSEARCH) {
                            store.dispatch("sPaymentPage/CLEAR_PAYMENT_STORE");
        
                            if (to.path == PATHNAME.FLIGHTSEARCH||to.path == PATHNAME.DASHBOARD) {
                                store.dispatch("sResult/CLEAR_RESULT_STORE");
                                store.dispatch('sMLResult/CLEAR_ML_RESULT_STORE')

                                //   EventBus.$emit('clearAllToast',true);
                                Vue.toasted.clear();


                            }
                        }
                    } else if (from.path == PATHNAME.SUCCESSPAGE) {
                        if (to.path == PATHNAME.PAYMENTPAGE || to.path == PATHNAME.PAXPAGE || to.path == PATHNAME.FLIGHTRESULTS || to.path == PATHNAME.FLIGHTSEARCH) {
                            store.dispatch("sPaymentPage/CLEAR_PAYMENT_STORE");
                            store.dispatch('sPaxPage/CLEAR_PAX_STORE')

                            if (to.path == PATHNAME.FLIGHTSEARCH||to.path == PATHNAME.DASHBOARD) {
                                store.dispatch("sResult/CLEAR_RESULT_STORE");
                                store.dispatch('sMLResult/CLEAR_ML_RESULT_STORE')

                                //   EventBus.$emit('clearAllToast',true);
                                Vue.toasted.clear();


                            }
                        }
                    } else if (from.path == PATHNAME.PENDINGPAGE) {
                        if (to.path == PATHNAME.PAYMENTPAGE || to.path == PATHNAME.PAXPAGE || to.path == PATHNAME.FLIGHTRESULTS || to.path == PATHNAME.FLIGHTSEARCH) {
                            store.dispatch("sPaymentPage/CLEAR_PAYMENT_STORE");
                            store.dispatch('sPaxPage/CLEAR_PAX_STORE')

                            if (to.path == PATHNAME.FLIGHTSEARCH||to.path == PATHNAME.DASHBOARD) {
                                store.dispatch("sResult/CLEAR_RESULT_STORE");
                                store.dispatch('sMLResult/CLEAR_ML_RESULT_STORE')

                                //   EventBus.$emit('clearAllToast',true);
                                Vue.toasted.clear();


                            }
                        }
                    } else if (from.path == PATHNAME.FAILEDPAGE) {
                        if (to.path == PATHNAME.PAYMENTPAGE || to.path == PATHNAME.PAXPAGE || to.path == PATHNAME.FLIGHTRESULTS || to.path == PATHNAME.FLIGHTSEARCH) {
                            store.dispatch("sPaymentPage/CLEAR_PAYMENT_STORE");
                            store.dispatch('sPaxPage/CLEAR_PAX_STORE')

                            if (to.path == PATHNAME.FLIGHTSEARCH||to.path == PATHNAME.DASHBOARD) {
                                store.dispatch("sResult/CLEAR_RESULT_STORE");
                                store.dispatch('sMLResult/CLEAR_ML_RESULT_STORE')

                                //   EventBus.$emit('clearAllToast',true);
                                Vue.toasted.clear();


                            }
                        }
                    } else if (from.path == PATHNAME.HOLDPAGE) {
                        if (to.path == PATHNAME.PAYMENTPAGE || to.path == PATHNAME.PAXPAGE || to.path == PATHNAME.FLIGHTRESULTS || to.path == PATHNAME.FLIGHTSEARCH) {
                            store.dispatch("sPaymentPage/CLEAR_PAYMENT_STORE");
                            store.dispatch('sPaxPage/CLEAR_PAX_STORE')

                            if (to.path == PATHNAME.FLIGHTSEARCH||to.path == PATHNAME.DASHBOARD) {
                                store.dispatch("sResult/CLEAR_RESULT_STORE");
                                store.dispatch('sMLResult/CLEAR_ML_RESULT_STORE')

                                //    EventBus.$emit('clearAllToast',true);
                                Vue.toasted.clear();


                            }
                        }
                    } else if (from.path == PATHNAME.PAYMENTPAGE) {
                        if (to.path == PATHNAME.PAXPAGE || to.path == PATHNAME.FLIGHTRESULTS || to.path == PATHNAME.FLIGHTSEARCH) {
                            store.dispatch("sPaymentPage/CLEAR_PAYMENT_STORE");
                            //  EventBus.$emit('clearAllToast',true);
                            Vue.toasted.clear();


                            // store.dispatch("sPaxPage/CLEAR_PAX_STORE");
                            if (to.path == PATHNAME.FLIGHTSEARCH||to.path == PATHNAME.DASHBOARD) {
                                store.dispatch("sResult/CLEAR_RESULT_STORE");
                                store.dispatch('sMLResult/CLEAR_ML_RESULT_STORE')

                            }

                        }

                    } else if (from.path == PATHNAME.PAXPAGE) {
                        if (to.path == PATHNAME.FLIGHTRESULTS || to.path == PATHNAME.FLIGHTSEARCH) {
                            EventBus.$emit('clearAllToast', true);
                        }
                        if (to.path == PATHNAME.FLIGHTSEARCH||to.path == PATHNAME.DASHBOARD) {
                            store.dispatch("sResult/CLEAR_RESULT_STORE");
                            store.dispatch('sMLResult/CLEAR_ML_RESULT_STORE')

                        }

                        // } else if (from.path == PATHNAME.PAYMENTPAGE) {
                        //     if (to.path == PATHNAME.PAXPAGE || to.path == PATHNAME.FLIGHTRESULTS || to.path == PATHNAME.FLIGHTSEARCH) {
                        //         store.dispatch("sPaymentPage/CLEAR_PAYMENT_STORE");
                        //  EventBus.$emit('clearAllToast');

                    } else if (from.path == PATHNAME.FLIGHTRESULTS) {
                        if (to.path == PATHNAME.FLIGHTSEARCH||to.path == PATHNAME.DASHBOARD) {
                            Vue.toasted.clear();
                          
                            // store.dispatch("sResult/CLEAR_RESULT_STORE");
                            // store.dispatch('sMLResult/CLEAR_ML_RESULT_STORE')
                            // EventBus.$emit('clearAllToast',true);
                            //   console.error(Vue.toasted.clear())


                        }
                    } else if (from.path == PATHNAME.ADD_USER && to.path == PATHNAME.MANAGE_USERS) {
                        store.dispatch("sManageUsers/CLEAR_MANAGE_USERS_STORE");
                    } else if (from.path == PATHNAME.TOPUP_REPORT) {
                        store.dispatch('sSystemTopUp/CLEAR_SYSTEM_TOPUP_STORE')
                    }

                    else if (
                        (from.path == PATHNAME.TICKETING_QUEUE_DETAIL && to.path != PATHNAME.TICKET_NOW) || 
                        (from.path == PATHNAME.MY_BOOKING_DETAIL)  
                       
                        ) {

                    /*else if ((from.path == PATHNAME.TICKETING_QUEUE_DETAIL &&( to.path != PATHNAME.TICKET_NOW || to.path != PATHNAME.REFUND))
                        || (from.path == PATHNAME.MY_BOOKING_DETAIL && to.path != PATHNAME.REFUND )) {*/   
                            if(to.path != PATHNAME.REFUND && to.path!=PATHNAME.EXCHANGE)                   
                        store.dispatch("sTicketingQueue/CLEAR_TICKETING_QUEUE_STORE");
                    }
                    else if(
                        (from.path == PATHNAME.BOOKING_DETAILS &&to.path != PATHNAME.TICKET_NOW&&to.path!=PATHNAME.TICKETING_QUEUE) ||
                        (from.path==PATHNAME.TICKETING_QUEUE&&to.path!=PATHNAME.TICKET_NOW&&to.path!=PATHNAME.BOOKING_DETAILS)||
                        (from.path==PATHNAME.TICKET_NOW&&to.path!=PATHNAME.BOOKING_DETAILS&&to.path!=PATHNAME.TICKETING_QUEUE)||
                        (to.path==PATHNAME.TICKET_NOW&&from.path!=PATHNAME.TICKETING_QUEUE&&from.path!=PATHNAME.BOOKING_DETAILS) 
                       
                        ){

                    /*else if((from.path == PATHNAME.TICKETING_QUEUE_DETAIL
                          &&to.path != PATHNAME.TICKET_NOW&&to.path!=PATHNAME.TICKETING_QUEUE) ||
                          (from.path==PATHNAME.TICKETING_QUEUE&&to.path!=PATHNAME.TICKET_NOW&&to.path!=PATHNAME.TICKETING_QUEUE_DETAIL)||
                          (from.path==PATHNAME.TICKET_NOW&&to.path!=PATHNAME.TICKETING_QUEUE_DETAIL&&to.path!=PATHNAME.TICKETING_QUEUE)||(to.path==PATHNAME.TICKET_NOW&&from.path!=PATHNAME.TICKETING_QUEUE&&from.path!=PATHNAME.TICKETING_QUEUE_DETAIL)||(to.path != PATHNAME.REFUND)
                          ){*/
                            // ||(to.path==PATHNAME.TICKET_NOW&&from.path!=PATHNAME.TICKETING_QUEUE&&from.path!=PATHNAME.TICKETING_QUEUE_DETAIL)||(to.path)
                            // store.dispatch('cBookingDetail/CLEAR_BOOKING_DETAIL_STORE')
                            if(to.path != PATHNAME.REFUND && to.path!=PATHNAME.EXCHANGE)
                            store.dispatch('cTicketingDetail/CLEAR_TICKETING_DETAIL_STORE')
                          }
                          else if(
                            (from.path == PATHNAME.BOOKING_DETAILS &&to.path != PATHNAME.TICKET_NOW&&to.path!=PATHNAME.MY_BOOKING) ||                            
                            (from.path==PATHNAME.MY_BOOKING&&to.path!=PATHNAME.TICKET_NOW&&to.path!=PATHNAME.BOOKING_DETAILS)|| 
                            (from.path==PATHNAME.TICKET_NOW&&to.path!=PATHNAME.BOOKING_DETAILS&&to.path!=PATHNAME.MY_BOOKING)||
                            (to.path==PATHNAME.TICKET_NOW&&from.path!=PATHNAME.MY_BOOKING&&from.path!=PATHNAME.BOOKING_DETAILS) || 
                            (from.path==PATHNAME.TICKET_NOW&&to.path!=PATHNAME.BOOKING_DETAILS&&to.path!=PATHNAME.MY_BOOKING )
                            ){

                          /*else if((from.path == PATHNAME.MY_BOOKING_DETAIL
                            &&to.path != PATHNAME.TICKET_NOW&&to.path!=PATHNAME.MY_BOOKING && to.path != PATHNAME.REFUND) ||
                            (from.path==PATHNAME.MY_BOOKING&&to.path!=PATHNAME.TICKET_NOW&&to.path!=PATHNAME.MY_BOOKING_DETAIL)|| (from.path==PATHNAME.TICKET_NOW&&to.path!=PATHNAME.MY_BOOKING_DETAIL&&to.path!=PATHNAME.MY_BOOKING)||(to.path==PATHNAME.TICKET_NOW&&from.path!=PATHNAME.MY_BOOKING&&from.path!=PATHNAME.MY_BOOKING_DETAIL)){*/
                                if(to.path != PATHNAME.REFUND && to.path!=PATHNAME.EXCHANGE)
                              store.dispatch('cBookingDetail/CLEAR_BOOKING_DETAIL_STORE')
                            }  
                            else if((to.path==PATHNAME.ALL_REFUND&&from.path!=PATHNAME.REFUND_DET)||(from.path==PATHNAME.ALL_REFUND&&to.path!=PATHNAME.REFUND_DET)){
                                store.dispatch('sAllRefund/CLEAR_ALL_REFUND_STORE')
                            } 
                            else if((to.path==PATHNAME.ALL_EXCHANGE&&from.path!=PATHNAME.EXCHANGE_DET)||(from.path==PATHNAME.ALL_EXCHANGE&&to.path!=PATHNAME.EXCHANGE_DET)){
                                store.dispatch('sAllExchange/CLEAR_ALL_EXCHANGE_STORE')

                            } 

                   
                        }

                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.ROUTER,
                        "error in handleBackFlow",
                        err.toString(),
                        "handleBackFlow",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }

            }



            function getConfirmAndGoNext() {
                // EventBus.$dialog.confirm('<span>Confirmation </span><div> You have unsaved changes. Are you sure you want to leave this page?</div>')
                // if(!EventBus.$dialog.mounted){
                EventBus.$dialog.confirm(i18n.tc('index.leaveCnfrmTxt'))
                    .then(function () {
                        updateDataEdited(false);
                         getRenew();
                         handleBackFlow();
                        next(); //confirmed
                    })
                    .catch(function () {
                        next(false); //cancelled
                    });
            // }
        }

        


        } catch (err) {
            if (navigator.onLine) {
                let body = Logger.buildRequest(
                    FILE_NAME.ROUTER,
                    "error in Router.beforeEach",
                    err.toString(),
                    "Router.beforeEach()",
                    LOG_TYPE.ERROR
                );

                Logger.getResponse(body);
            }
        }
    });

export default Router;